export default __webpack_public_path__ + "static/media/telkom.70992714.jpg";